import { Injectable, inject } from '@angular/core';
import { MatterportOauthApiService } from '@simOn/matterport/auth/data-access';
import { accessTokenExpiresInSeconds } from '@simOn/matterport/auth/models';
import { MatterportTokenFetcher, MatterportTokenInfo } from '@simlab/matterport';
import { Observable, map } from 'rxjs';

/**
 * Feeds the Showcase SDK token refresher (see `MATTERPORT_TOKEN_FETCHER` in the lib) with apartment tokens
 * from the backend. The backend always returns a valid token together with its expiry.
 */
@Injectable({ providedIn: 'root' })
export class MatterportTokenFetcherService implements MatterportTokenFetcher {
  private readonly _matterportOauthApiService = inject(MatterportOauthApiService);

  fetchToken$(): Observable<MatterportTokenInfo> {
    return this._matterportOauthApiService.getMatterportApartmentAccessToken().pipe(
      map((response) => ({
        accessToken: response.accessToken,
        // Without an expiry the refresher cannot schedule anything - 0 makes it refresh right away.
        expiresIn: accessTokenExpiresInSeconds(response) ?? 0
      }))
    );
  }
}
